import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Home from "./containers/home";
import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-react/styles.css";
import awsconfig from './aws-exports.js'; // ? correct syntax

import FaceVerify from "./containers/faceVerify";
import Success from "./containers/success";
import NotFound from "./containers/notFound";
import LandingPage from "./containers/landingPage";
import "./styles/global.css";
import PrivacyAndPolicy from "./containers/privacy";
import TermsAndConditions from "./containers/termsAndConditions";
import Verified from "./containers/verified";
import UnVerified from "./containers/unVerified";
import LoadingQrCode from "./containers/loadingQrCode";
import ErrorPage from "./containers/error";
import NoCamera from "./containers/noCamera";
import CameraPermission from "./containers/cameraPermission";
// import HelpIcon from "./components/HelpIcon";
import MobileCompleted from "./containers/mobileCompleted";
import BackofficeLogin from "./containers/backoffice/Login";
import BackofficeLayout from "./containers/backoffice/Layout";
import BackofficeDashboard from "./containers/backoffice/Dashboard";
import BackofficeClients from "./containers/backoffice/Clients";
import BackofficeTelescope from "./containers/backoffice/Telescope";
import PrivateRoute from "./containers/backoffice/PrivateRoute";
import DocumentCapture from "./containers/documentCapture";

import debugLogger from "./utils/debug";
import { logger } from "./store/middleware/consoleEventLogger";
import useNavigationWarning from "./hooks/useNavigationWarning";
import { useLanguage } from "./contexts/LanguageContext";
import { setCurrentPage } from "./store/actions";

Amplify.configure(awsconfig);
debugLogger.log('Amplify configured', { awsconfig });

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useLanguage();
  const remoteDebugEnabled = useSelector(state => state.remoteDebugEnabled);

  // Enable navigation warning for verification pages
  const isVerificationPage = [
    '/verification/',
    '/document/',
    '/process/',
    '/camera-permission'
  ].some(path => location.pathname.includes(path));

  // Use the navigation warning hook with localized message
  useNavigationWarning(
    t.navigationWarning.message,
    isVerificationPage
  );

  // Debug route changes and dispatch to Redux
  useEffect(() => {
    debugLogger.navigation('App', location.pathname, {
      search: location.search,
      state: location.state
    });
    dispatch(setCurrentPage(location.pathname));
  }, [location, dispatch]);

  // Debug component mount
  useEffect(() => {
    debugLogger.componentMount('App', {});
    if (remoteDebugEnabled) {
      logger.log('🔍 Remote Debug enabled - Redux DevTools logs are being sent to backend');
    }
    return () => {
      debugLogger.componentUnmount('App');
    };
  }, [remoteDebugEnabled]);

  return (
    // <Authenticator>
    // {({ signOut, user }) => (
    <main>
        {/* <header>
                <h1>Welcome {user?.username}</h1>
                <button onClick={signOut}>Sign out</button>
              </header> */}

        <Routes>
          <Route path="/backoffice/login" element={<BackofficeLogin />} />
          <Route path="/backoffice" element={<PrivateRoute />}>
            <Route element={<BackofficeLayout />}>
              <Route index element={<BackofficeDashboard />} />
              <Route path="clients" element={<BackofficeClients />} />
              <Route path="telescope" element={<BackofficeTelescope />} />
            </Route>
          </Route>

          <Route path="/varification" element={<LandingPage />} />
          <Route path="/verification/:sessionId" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyAndPolicy />} />
          <Route path="/terms-and-condition" element={<TermsAndConditions />} />
          <Route path="/verified" element={<Verified />} />
          <Route path="/error" element={<ErrorPage />} />
          {/* Document capture runs before liveness and on its own mount: the
              liveness page patches getUserMedia to force the front camera. */}
          <Route path="/document/:sessionId" element={<DocumentCapture />} />
          <Route path="/process/:sessionId" element={<FaceVerify />} />
          <Route path="/camera-permission" element={<CameraPermission />} />
          <Route path="/success" element={<Success />} />
          <Route path="/loading-qr-code" element={<LoadingQrCode />} />
          <Route path="/no-camera/:sessionId" element={<NoCamera />} />
          <Route path="/mobile-completed" element={<MobileCompleted />} />
          <Route path="/failed" element={<ErrorPage />} />
          <Route path="/session-canceled" element={<ErrorPage />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* Help Icon - appears on all pages */}
        {/* <HelpIcon /> */}
      </main>
    //   )}
    // </Authenticator>
  );
}

export default App;
